import { Injectable } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';

import { BaseChartConfig, toUTCDateMs } from 'src/app/shared/components/disease-insight-chart/base-chart.config';
import { DiseaseChartDay } from 'src/app/shared/components/disease-insight-chart/models';

@Injectable()
export class BlightChartConfig extends BaseChartConfig {
  getRightAxisTitle(): string {
    return 'mm';
  }

  getInfectionRiskLabel(localeService: LocaleService): string {
    return localeService.translate('blight.infectionRisk');
  }

  getIsHourlyData(): boolean {
    return true;
  }

  override getIsInfectionRiskHourly(): boolean {
    return true;
  }

  override extractInfectionRisks(days: DiseaseChartDay[]): Array<[number, number]> {
    const blightInfectionRisks: Array<[number, number]> = [];

    for (const day of days) {
      if (!day.infectionRiskPerHour?.length) {
        continue;
      }

      for (let hour = 0; hour < day.infectionRiskPerHour.length; hour++) {
        const infectionRisk = day.infectionRiskPerHour[hour];
        if (infectionRisk == null) {
          continue;
        }

        blightInfectionRisks.push([toUTCDateMs(new Date(day.date), hour), infectionRisk]);
      }
    }

    return blightInfectionRisks;
  }
}
